import React, { useState } from "react";
import { ShieldCheck, Clock, Users, Headphones } from "lucide-react";
import BookConsultModal from "./BookConsultModal";

const features = [
  {
    id: 1,
    icon: <ShieldCheck size={36} />,
    title: "Long-Lasting Protection",
    description:
      "Premium waterproofing materials protect your home from leaks and seepage for years.",
  },
  {
    id: 2,
    icon: <Clock size={36} />,
    title: "On-Time Completion",
    description:
      "Expert team ensures timely project completion with a smooth and hassle-free process.",
  },
  {
    id: 3,
    icon: <Users size={36} />,
    title: "Experienced Professionals",
    description:
      "Certified waterproofing specialists with years of hands-on experience.",
  },
  {
    id: 4,
    icon: <Headphones size={36} />,
    title: "After-Service Support",
    description:
      "Reliable after-service support ensures peace of mind even after project completion.",
  },
];

const WhyChooseUsWaterproofing = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="bg-gray-100 py-24 px-6 font-sans relative">
      <div className="max-w-7xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-serif font-black text-neutral-900 mb-3">
            Why Choose Us
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-base">
            Trusted waterproofing experts delivering long-lasting protection and peace of mind.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 ">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="relative bg-white/70 backdrop-blur-md rounded-2xl p-8 shadow-lg
                         hover:shadow-2xl hover:scale-105 transform transition-all duration-500"
            >
              {/* Icon Circle */}
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 w-16 h-16
                              flex items-center justify-center rounded-full bg-amber-100 text-amber-600">
                {feature.icon}
              </div>

              <div className="mt-12 text-center">
                <h3 className="text-xl font-serif font-semibold text-neutral-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-sm">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center mt-16">
          <button
            onClick={() => setIsModalOpen(true)}
            className="bg-amber-600 hover:bg-amber-700 text-white px-10 py-4 rounded-xl font-serif 
                       font-bold text-lg shadow-lg hover:shadow-amber-500/40 transition-all"
          >
            Get Free Inspection
          </button>
        </div>
      </div>

      {/* Modal */}
      <BookConsultModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default WhyChooseUsWaterproofing;
